import { amsAxios } from 'utils/axiosHelper';

export const verifyContactAPI = {
  getUser: (username) => {
    return amsAxios.get(`/users/manheim-customer/${username}`);
  },
  updateUser: (username, data) => {
    return amsAxios.post(`/users/manheim-customer/${username}`, data);
  },
  search: (contactValue, type) => {
    return amsAxios.get(`/users/manheim-customer/${type}/${contactValue}`);
  },

  sendVerify: (username, data) => {
  return amsAxios.post(
    `/users/manheim-customer/${username}/devices/pairings`,
    data
  );
},
};